import { DefaultPageHeader } from 'layouts';
import { Card, Skeleton } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { CommunitiesSlider } from 'features/communities/components/communities-slider';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useCommunitiesInfiniteQuery } from 'features/communities/queries/useCommunitiesInfiniteQuery';
import { ChannelsEmpty, EntityList } from '../components';
import { useOrganizationRequestContent } from '../hooks';

type P = {
  getPathToCommunityDetail: (id: string) => string;
  navigateToJoinedCommunities: () => Promise<void>;
  organizationId: string;
};

const ChannelsCommunities = ({ getPathToCommunityDetail, navigateToJoinedCommunities, organizationId }: P) => {
  const { allOrganizations, isLoadingOrganizations, requestOrganizationId } = useOrganizationRequestContent({
    organizationId,
  });

  const {
    data: allCommunitiesData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useCommunitiesInfiniteQuery({
    filter: { organizationId: requestOrganizationId, scope: 'channels' },
    pagination: { pageSize: 12 },
  });

  const allCommunities = allCommunitiesData?.pages.flatMap((communitiesPaginated) => communitiesPaginated.data);

  return (
    <>
      <DefaultPageHeader title="Communities" />
      {isLoadingOrganizations || isLoadingAll || !allCommunities || !allOrganizations ? (
        <Skeleton active paragraph={{ rows: 16 }} />
      ) : (
        <>
          <CommunitiesSlider
            controls={{ title: 'Featured' }}
            getPathToCommunityDetail={getPathToCommunityDetail}
            query={{ filter: { organizationId: requestOrganizationId, scope: 'channels' } }}
          />
          <Card title={<Card.Title level={2}>All</Card.Title>}>
            <EntityList
              empty={<ChannelsEmpty navigateToJoined={navigateToJoinedCommunities} scope="communities" />}
              entities={allCommunities.map((community) => ({
                data: community,
                type: 'Community',
              }))}
              fetchNextPage={fetchNextPage}
              getPathToEntityDetail={getPathToCommunityDetail}
              hasNextPage={hasNextPage}
              isFetching={isFetchingAll}
              isLoading={isLoadingAll}
            />
          </Card>
        </>
      )}
    </>
  );
};

export default ChannelsCommunities;
